import React from 'react';
import { Box, Text } from '@vibe/core';
import { Truck, AlertCircle } from 'lucide-react';

/**
 * Shipping status badge component
 * Displays free shipping status for Amazon.com items
 * 
 * @param {Object} props - Component props
 * @param {boolean|null} props.freeShippingToIsrael - Whether shipping is free (true), paid (false), or unknown (null)
 * @param {number|null} props.shippingCostToIsrael - Shipping cost in ILS (optional)
 * @param {string} props.domain - Item domain (only shows for 'com')
 */
const ShippingStatusBadge = ({ freeShippingToIsrael, shippingCostToIsrael, domain }) => {
  // Only show for Amazon.com items
  if (domain !== 'com') {
    return null;
  }

  // Don't show if status is unknown
  if (freeShippingToIsrael === null || freeShippingToIsrael === undefined) {
    return null;
  }

  const isFree = freeShippingToIsrael === true;
  const badgeColor = isFree ? '#059669' : '#6b7280';
  const bgColor = isFree ? '#d1fae5' : '#f3f4f6';
  const borderColor = isFree ? '#10b981' : '#d1d5db';
  const textColor = isFree ? '#065f46' : '#374151';

  return (
    <Box
      className="shipping-status-badge"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 8px',
        borderRadius: '6px',
        backgroundColor: bgColor,
        border: `1px solid ${borderColor}`,
        fontSize: '12px',
        fontWeight: 500,
      }}
    >
      <Truck size={12} style={{ color: badgeColor }} />
      <Text
        type="text2"
        style={{
          color: textColor,
          fontSize: '12px',
          fontWeight: 500,
        }}
      >
        {isFree ? (
          'משלוח חינם לישראל'
        ) : (
          shippingCostToIsrael ? (
            `משלוח בתשלום: ${shippingCostToIsrael.toFixed(2)}₪`
          ) : (
            'משלוח בתשלום לישראל'
          )
        )}
      </Text>
    </Box>
  );
};

export default ShippingStatusBadge;

